import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core'

import { ReplaySubject,
         Observable } from 'rxjs';

// import { createHash } from 'crypto';
import { Md5 } from 'ts-md5';
import { Service } from '../_models/service.model';


@Injectable()
export class AppHelper {

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
  ){}

  public componentDestroyed(component: any): ReplaySubject<any> {
    const oldNgOnDestroy = component.ngOnDestroy;
    const destroyed$ = new ReplaySubject<void>(1);
    component.ngOnDestroy = () => {
      oldNgOnDestroy.apply(component);
      destroyed$.next(undefined);
      destroyed$.complete();
    };
    return destroyed$;
  }

  public currentPath() {
    console.log('TODO: currentPath', window.location, this.baseHref)
    
  }


  // 
  // relativeTime and getDuration based on ss relative-date.pipe
  // orig: https://gist.github.com/JonCatmull/e00afb1c96298a4e386ea1b5d091702a
  getDuration(timeAgoInSeconds: number, abbr = false) {
    let isPast = timeAgoInSeconds > 0
    let epochs = [
      { seconds: 31536000, name: 'year', abbr: 'year'},
      { seconds: 2592000, name: 'month', abbr: 'month'},
      { seconds: 86400, name: 'day', abbr: 'day'},
      { seconds: 3600, name: 'hour', abbr: 'hr'},
      { seconds: 60, name: 'minute', abbr: 'min'},
      { seconds: 1, name: 'second', abbr: 'sec'}
    ]
    let intervalOut = 0
    let epoch = 'second'

    // for (let [name, seconds] of epochs) {
    for (let epoch of epochs) {
      let sec = epoch['seconds']
      let interval = Math.floor(Math.abs(timeAgoInSeconds) / sec)
      if (interval < 1) continue
      // console.log('INTERVAL', name, interval, timeAgoInSeconds, sec)
      // intervalOut = interval
      let remainingAbs = Math.abs(timeAgoInSeconds) - Math.abs((interval * sec))
      return { 
        interval: interval, 
        epoch: abbr ? epoch['abbr'] : epoch['name'],
        remaining: isPast ? 0 - remainingAbs : remainingAbs
      }
    }
  }


  // datestamp should be in ms
  relativeTime(datestamp: any, params={}): (string|string[]) {
    // console.log('PARAMS', params, typeof params)
    let showDescriptor = typeof params['showDescriptor']!=='undefined' ? params['showDescriptor'] : true
    let levels = params['levels'] || 2
    let timeNowUtc = new Date().getTime()
    // let timestamp = new Date(datestamp).getTime()
    let timeAgoInSeconds  = Math.floor((timeNowUtc - datestamp) / 1000)

    // let {interval, epoch, remaining} = this.getDuration(timeAgoInSeconds)
    let outArray = []
    let timeChunk = timeAgoInSeconds
    
    let ago               = showDescriptor && timeAgoInSeconds >= 0 ? ' ago' : ''
    let _in               = showDescriptor && timeAgoInSeconds < 0 ? 'in ' : '' 
    let outArr = [`${_in}`]
    let outObj = []

    for (let l = 0; l < levels; l++) {
      let duration = this.getDuration(timeChunk)
      if (!duration) return
      let {interval, epoch, remaining} = duration
      // outArray.push(duration)

      if (params['asObject']) {
        outObj.push({interval: interval, epoch: epoch})
      } else {
        let suffix = interval === 1 ? '' : 's'
        outArr.push(`${interval}`)
        outArr.push(`${epoch}${suffix}`)
      }
      timeChunk = remaining
      // console.log('out?', outArr, levels, remaining)
      if (remaining === 0) break
    }

    // console.log('out', outObj, outArr)

    if (params['asObject']) {
      return outObj
    } else {
      outArr.push(`${ago}`)
    }

    if (params['asArray']) return outArr
    let out = outArr.join(' ')
    return out
  }

  gravatarHash(email: string = '') {
      // Ensure email is a string
      email = (typeof email === 'string') ? email : '';
      
      // Trim the leading and trailing whitespaces
      let trimmed = email.trim();
      // console.log('trimmed', trimmed)
      
      // Transform to all lowercase characters
      let lowercase = trimmed.toLowerCase();
      
      // Compute the MD5 hash
      // const hash = createHash('md5').update(email).digest('hex');
      let hash = Md5.hashStr(lowercase)
      console.log('email', lowercase, hash)
      return hash;
  }


  percentageSequence(keys = 100) {
    let scale = keys/100
    let sequence = Array.from(Array(keys).keys()).map(i => parseFloat(((i+1) * (0.01 / scale)).toFixed(3)))
    // console.log('percentageSequence', sequence)
    return sequence
  }

  defaultPaginationOptions() {
    return {
      limit: 50,
      page: 0, 
      sortBy: 'id:DESC',
    }
  }

  serviceList(services: Service[]): string {
    return services.map(svc => svc.slug).join(', ')
  }

  servicePriceList(services: Service[]): string {
    if (!services) return
    let out = services.map(svc => {
      svc = new Service(svc)
      if (!svc.price) return console.log("ERR: !svc.price", svc)
      // let dollar_price = svc.dollar_price.toFixed(2);
      let dollar_price = svc.dollar_price
      // console.log('DP', dollar_price, svc)
      return `${svc.dollar_price} ${svc.slug}`
    }).join('\n')
    // console.log('PRICE LIST', out)
    return out
  }

  isServicesField(field: string) {
    return field == 'services'
  }

  isNameField(field: string) {
    return ['first_name','last_name'].indexOf(field) > -1
  }

  isPaymentsField(field: string) {
    return field == 'payments'
  }

  // REPLACED with get full_name() at Order
  // firstLastName(entity: any) {
  //   let name = entity['first_name']
  //   if (entity['last_name']) name += ` ${entity['last_name']}`
  //   // console.log('firstLastName', name)
  //   return name
  // }

  isDatePipeField(field: string) {
    return ['created_at','updated_at'].indexOf(field) > -1
  }

  expandTextareaToContent(nativeElement) {
    // console.log('UTH', nativeElement)
    nativeElement.style.height = ''
    nativeElement.style.height = nativeElement.scrollHeight + 'px'
  }
  
  // htmlTextarea(content: string) {
  //   return content.replace('\n', '<br>')
  // }

  // returns random integer btw 0 & N (inclusive)
  getRandomInt(N) {
    return Math.floor(Math.random() * (N + 1)); 
  }
  
}